define('models/StoreServiceCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/StoreServiceModel'], function (_, ObjectCollection, LocalStorage, StoreServiceModel)
{
    //
    // Collection Store Service
    //
    var StoreServiceCollectionPrototype = {

        name: 'StoreServiceCollection',
        route: 'apiStoreServiceCollection',
        model: StoreServiceModel,
        initialize: function ()
        {
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this, arguments);

        },
        filterByType:function(type_shop){
            return _(this.filter(function(storeService){
                return storeService.get('type_shop_'+type_shop);
            }))
        }
    };

    var StoreServiceCollection = ObjectCollection.extend(LocalStorage).extend(StoreServiceCollectionPrototype);

    return StoreServiceCollection;
});
